exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fct-vertical-layout{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:stretch;align-items:stretch;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.fct-vertical-layout._left{-ms-flex-align:start;align-items:flex-start}.fct-vertical-layout._center{-ms-flex-align:center;align-items:center}.fct-vertical-layout._right{-ms-flex-align:end;align-items:flex-end}.fct-vertical-layout>*{position:relative;-ms-flex-negative:0;flex-shrink:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/less-loader!./layout/VerticalLayout.less
// module id = 167
// module chunks = 0